
import { Component, Vue } from 'vue-property-decorator';
import { State } from 'vuex-class';

@Component({
    components: {},
})
export default class Loader extends Vue {
    @State('loading')
    readonly loading!: boolean;

    @State('loadingMessage')
    readonly message!: string;
}
